import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { postBPDataWithoutParams } from 'src/business/services'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import {
  filterValidAndNonRepeatedEmails,
  prospectContactIsEmpty,
  workforceContactIsEmpty,
} from 'src/consumer/helpers/utilFunctions'
import { ClinicDataContext } from 'src/context/ClinicDataContext'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getMPData } from 'src/mentor/services'
import {
  BusinessOnboardingBody,
  BusinessOnboardingBodyHeading,
  BusinessOnboardingMain,
  BusinessOnboardingPage,
} from './ClinicOnboardingStyles'
import ClinicBrandOnboardingComponent from './clinicBrand/ClinicBrandOnboardingComponent'
import { sendInvitesToProspects } from '../profile/utils'

export default function ClinicBrandOnboardingPage() {
  const navigate = useNavigate()
  const { ownerData, refreshOwnerAssociatedClinicBrandsData } = useContext(ClinicDataContext)
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false)
  const [clinicBrandDetails, setClinicBrandDetails] = useState({
    ownerUserIds: [ownerData?.userProfileData?.userId],
    prospectOwnerEmailId: ownerData?.userProfileData?.email || '',
    prospects: {
      admins: [
        {
          email: '',
          mobile: '',
        },
      ],
      doctors: [
        {
          email: '',
          mobile: '',
        },
      ],
      therapists: [
        {
          email: '',
          mobile: '',
        },
      ],
      clinicAssistants: [
        {
          email: '',
          mobile: '',
        },
      ],
    },
    // prospectDoctorEmailIds: [''],
    // prospectTherapistEmailIds: [''],
    // prospectClinicAssistantEmailIds: [''],
  })
  const [teacherData, setTeacherData] = useState()

  async function getAndSetDoctorDataInClinicBrand() {
    if (
      getAllRolesInBoolean().isDoctor ||
      getAllRolesInBoolean().isTeacher ||
      getAllRolesInBoolean().isCreator
    ) {
      const resp = await getMPData('/api/secure/teacher/profile')
      if (resp?.status === 200 && resp?.data) {
        if (Array.isArray(resp?.data?.categories) && resp?.data?.categories?.includes('doctor')) {
          setTeacherData(resp?.data)
          // const brandNameFromSessionStorage = sessionStorage.getItem('brandTitle')
          setClinicBrandDetails((prev) => ({
            ...prev,
            // attachedDoctorUserIds: [ownerData?.userProfileData?.id],
            kycStatus: 'pending',
            workforce: {
              doctors: [
                {
                  id: resp?.data?.id,
                  uid: resp?.data?.id,
                  userId: resp?.data?.userId,
                  title: resp?.data?.name || resp?.data?.title,
                  email: resp?.data?.email, // not sure if it should go
                  mobile: resp?.data?.mobile, // not sure if it should go
                },
              ],
            },
          }))
        }
      }
    }
  }

  async function handleSubmit() {
    setSubmitButtonLoading(true)
    const doctorProspectEmails = clinicBrandDetails?.prospects?.doctors
      ?.filter((item) => {
        return !prospectContactIsEmpty(item)
      })
      ?.map((item) => item?.email)
    const therapistProspectEmails = clinicBrandDetails?.prospects?.therapists
      ?.filter((item) => {
        return !prospectContactIsEmpty(item)
      })
      ?.map((item) => item?.email)
    const clinicAssistantProspectEmails = clinicBrandDetails?.prospects?.clinicAssistants
      ?.filter((item) => {
        return !prospectContactIsEmpty(item)
      })
      ?.map((item) => item?.email)

    const dataToSubmit = {
      ...clinicBrandDetails,
      slug: clinicBrandDetails?.slug || clinicBrandDetails?.tempSlug || '',
      prospectDoctorEmailIds: filterValidAndNonRepeatedEmails(doctorProspectEmails),
      prospectTherapistEmailIds: filterValidAndNonRepeatedEmails(therapistProspectEmails),
      prospectClinicAssistantEmailIds: filterValidAndNonRepeatedEmails(
        clinicAssistantProspectEmails,
      ),
      workforce: {
        ...clinicBrandDetails?.workforce,
        doctors:
          clinicBrandDetails?.workforce?.doctors?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
        therapists:
          clinicBrandDetails?.workforce?.therapists?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
        clinicAssistants:
          clinicBrandDetails?.workforce?.clinicAssistants?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
        admins:
          clinicBrandDetails?.workforce?.admins?.filter((item) => {
            return !prospectContactIsEmpty(item) || !workforceContactIsEmpty(item)
          }) || [],
      },
      prospects: {
        ...clinicBrandDetails?.prospects,
        doctors:
          clinicBrandDetails?.prospects?.doctors?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
        therapists:
          clinicBrandDetails?.prospects?.therapists?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
        clinicAssistants:
          clinicBrandDetails?.prospects?.clinicAssistants?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
        admins:
          clinicBrandDetails?.prospects?.admins?.filter((item) => {
            return !prospectContactIsEmpty(item)
          }) || [],
      },
      apiParam: 'clinic-brand',
      enabled: true,
    }

    const responseSaveClinicBrand = await postBPDataWithoutParams(
      '/api/secure/cp/clinic-brand/save',
      dataToSubmit,
    )
    if (isCommonResponseSuccessful(responseSaveClinicBrand.data.code)) {
      await Promise.all([
        refreshOwnerAssociatedClinicBrandsData(),
        sendInvitesToProspects(responseSaveClinicBrand?.data?.data?.['clinic-brand']),
      ])
    }
    setSubmitButtonLoading(false)
    navigate('/clinic-home')
  }

  useEffect(() => {
    console.log({ teacherData })
  }, [])

  useEffect(() => {
    getAndSetDoctorDataInClinicBrand()
  }, [])

  return (
    <BusinessOnboardingPage>
      <PublicAppHeader />
      <div style={{ marginBottom: '20px' }}></div>
      <BusinessOnboardingMain>
        <BusinessOnboardingBody useMaxWidth maxWidth="768px">
          <BusinessOnboardingBodyHeading>Clinic Brand Details</BusinessOnboardingBodyHeading>
          <ClinicBrandOnboardingComponent
            clinicBrand={clinicBrandDetails}
            ownerUserData={ownerData?.userProfileData}
            saveClinicBrand={handleSubmit}
            setClinicBrand={setClinicBrandDetails}
            savingClinicBrand={submitButtonLoading}
            teacherData={teacherData}
          />
        </BusinessOnboardingBody>
      </BusinessOnboardingMain>
    </BusinessOnboardingPage>
  )
}
